export default 
[
  {
    id: 1, 
    nome: 'Docente'
  },
  {
    id: 2, 
    nome: 'Técnico'
  },
  {
    id: 3, 
    nome: 'Administrativo'
  },
]



// WEBPACK FOOTER //
// ./FrontEnd/js/tipos-quadro-usp.js